var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667V5.33333C0 6.31667 0.794444 7.11111 1.77778 7.11111H2.66667H5.33333V2.66667C5.33333 1.19444 4.13889 0 2.66667 0C1.19444 0 0 1.19444 0 2.66667ZM6.22222 0C6.77778 0.744444 7.11111 1.66667 7.11111 2.66667V19.5556C7.11111 21.5167 8.70556 23.1111 10.6667 23.1111C12.6278 23.1111 14.2222 21.5167 14.2222 19.5556V19.2611C14.2222 17.4611 15.6833 16 17.4833 16H26.6667V5.33333C26.6667 2.38889 24.2778 0 21.3333 0H6.22222ZM25.7778 24.8889C29.2167 24.8889 32 22.1056 32 18.6667C32 18.1778 31.6 17.7778 31.1111 17.7778H17.4833C16.6667 17.7778 16 18.4389 16 19.2611V19.5556C16 22.5 13.6111 24.8889 10.6667 24.8889H20.4444H25.7778Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPaper);
export default __webpack_public_path__ + "static/media/big-paper.fe3cba77b8f875e17ad7869d42f692e7.svg";
export { ForwardRef as ReactComponent };